// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__QGEIs","text":"NoData_text__-KzS0","buttonContainer":"NoData_buttonContainer__rIf6Z","button":"NoData_button__ChEu4"};